const cancelJobOptions = [
  {
    label: 'Select Reason (Required)',
    value: 'none',
  },
  {
    label: 'No Gate Pass',
    value: 'No Gate Pass',
  },
  {
    label: 'Reroute Truck',
    value: 'Reroute Truck',
  },
  {
    label: 'Equipment Failure',
    value: 'Equipment Failure',
  },
  {
    label: 'Time Restrictions',
    value: 'Time Restrictions',
  },
  {
    label: 'Driver Issues (sick or unavailable)',
    value: 'Driver Issues (sick or unavailable)',
  },

  {
    label: 'Job Not as Advertised (INOP)',
    value: 'Job Not as Advertised (INOP)',
  },
  {
    label: 'Job Not as Advertised (Oversized)',
    value: 'Job Not as Advertised (Oversized)',
  },
  {
    label: 'No keys',
    value: 'No Keys',
  },
  {
    label: 'Vehicle Not Ready',
    value: 'Vehicle Not Ready',
  },
  {
    label: 'Accidental Booking',
    value: 'Accidental Booking',
  },
  {
    label: 'Pickup Location will not release vehicle',
    value: 'Pickup Location will not release vehicle',
  },
  {
    label: 'Pickup Location Unresponsive',
    value: 'Pickup Location Unresponsive',
  },
  {
    label: 'ACV Cancelled a Paired Load',
    value: 'ACV Cancelled a Paired Load',
  },
  {
    label: 'Incorrect Address',
    value: 'Incorrect Address',
  },
  {
    label: 'Weather',
    value: 'Weather',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

export default cancelJobOptions;
